module.exports = {
    controller: scheduleBGeneralNotesPageController,
    templateUrl: 'us/components/schedule-b-general-notes-page.html',
};

scheduleBGeneralNotesPageController.$inject = [
    '$analytics',
    '$location',
    'notificationsService'
];

function scheduleBGeneralNotesPageController(
    $analytics,
    $location,
    notifications
) {
    var vm = {
        $onInit: attached,
        $onDestroy: detached,
    };
    return vm;

    function attached() {
        $analytics.pageTrack('/schedule-b-general-notes');
        notifications.subscribe('filter_movement_changed', movementChanged)
    }

    function detached() {
        notifications.unsubscribe('filter_movement_changed', movementChanged);
    }

    function movementChanged(movement) {
        if (movement === 'import') {
            $location.path('/hts-general-notes');
        }
    }
}